import React, { useState } from 'react';

const Result = ({ hit }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = () => {
        setIsExpanded(!isExpanded);
    };
    const getClaimBaseUrl = () => {
        console.log(process.env.NODE_ENV);
        // Use environment variable if available, fall back to UAT URL
        if (process.env.NODE_ENV === 'development') {
            console.log(process.env.REACT_APP_CLAIM_URL_BASE);
            return process.env.REACT_APP_CLAIM_URL_BASE;
        }
        
        const currentHostname = window.location.hostname;
        const baseUrl = currentHostname.startsWith('search.') 
            ? `https://${currentHostname.substring(7)}` 
            : `https://${currentHostname}`;
        
        return baseUrl;
    };
    return (
        <div key={hit.money}>
            <div
                className={`hit ${isExpanded ? "highlight" : ""}`}
                onClick={toggleExpand}
            >
                <div className="hit-detail name">
                    <strong>{hit.payee_name}</strong>
                </div>
                <div className="hit-detail amount">
                    <strong>
                        {new Intl.NumberFormat('en-AU', {
                            style: 'currency',
                            currency: 'AUD',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }).format(Number(hit.amount_unclaimed))}
                    </strong>
                </div>
                <div className="hit-detail suburb">
                    <strong>{hit.address_2}</strong>
                </div>
                <div className="hit-detail source">
                    <strong>{hit["claim_from"]}</strong>
                </div>
                <div className="hit-detail actions">
                    <div className="toggle-btn">
                        {isExpanded ? (
                            <>
                                <span>Less details</span>
                                <i className="fa fa-minus" aria-hidden="false" aria-label="Collapse details"></i>
                            </>
                        ) : (
                            <>
                                <span>More details</span>
                                <i className="fa fa-plus" aria-hidden="false" aria-label="Expand details"></i>
                            </>
                        )}
                    </div>
                </div>
            </div>

            <div className={`expanded-content ${isExpanded ? "expanded" : ""}`}>
                <div className="row">
                    <div className="d-title col-3">
                        <strong>Notification No</strong>
                    </div>
                    <div className="d-value col-9">{hit.notification_no}</div>
                </div>

                <div className="row">
                    <div className="d-title col-3">
                        <strong>Payee/Owner Name</strong>
                    </div>
                    <div className="d-value col-9">{hit.payee_name}</div>
                </div>

                <div className="row">
                    <div className="d-title col-3">
                        <strong>Address</strong>
                    </div>
                    <div className="d-value col-9">{hit.address_2}</div>
                </div>

                <div className="row">
                    <div className="d-title col-3">
                        <strong>Amount($AUD)</strong>
                    </div>
                    <div className="d-value col-9">
                        {new Intl.NumberFormat('en-AU', {
                            style: 'currency',
                            currency: 'AUD',
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }).format(Number(hit.amount_unclaimed))}
                    </div>
                </div>

                <div className="row">
                    <div className="d-title col-3">
                        <strong>Date payable</strong>
                    </div>
                    <div className="d-value col-9">{hit.date_payable}</div>
                </div>

                <div className="row">
                    <div className="d-title col-3">
                        <strong>Description</strong>
                    </div>
                    <div className="d-value col-9">{hit.description}</div>
                </div>

                <div className="row">
                    <div className="d-title col-3">
                        <strong>Payer/Source</strong>
                    </div>
                    <div className="d-value col-9">{hit["payer_/_source"]}</div>
                </div>
                {hit["claim_from"] !== "DEPARTMENT OF TREASURY AND FINANCE" ? (
                    <div className="claim-from">
                        <div className="row">
                            <div className="col-12">
                                <h3>Contact for Claims and Enquiries</h3>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                Money Held by {hit["payer_/_source"]}
                                <br />
                                <br />
                            </div>
                        </div>

                        <div className="row">
                            <div className="d-title col-3">
                                <strong>Contact Name</strong>
                            </div>
                            <div className="d-value col-9">{hit["holder_contact_name"]}</div>
                        </div>

                        <div className="row">
                            <div className="d-title col-3">
                                <strong>Contact Phone</strong>
                            </div>
                            <div className="d-value col-9">{hit["holder_contact_phone"]}</div>
                        </div>

                        <div className="row">
                            <div className="d-title col-3">
                                <strong>Contact Email</strong>
                            </div>
                            <div className="d-value col-9">{hit["holder_contact_email"]}</div>
                        </div>

                        <div className="row">
                            <div className="d-title col-3">
                                <strong>Address 1</strong>
                            </div>
                            <div className="d-value col-9">{hit["holder_address_1"]}</div>
                        </div>

                        <div className="row">
                            <div className="d-title col-3">
                                <strong>Address 2</strong>
                            </div>
                            <div className="d-value col-9">{hit["holder_address_2"]}</div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <strong>Note</strong>
                            </div>
                            <div className="col-12">
                                <ul className="note-list">
                                    <li>Department of Treasury and Finance does not hold the money for this listing and has only published this information for public reference.</li>
                                    <li>All claims and inquiries regarding this money should be directed to {hit["payer_/_source"]}</li>
                                    <li>If required, you may need to refer to the <a href="http://www.whitepages.com.au" target="_blank">Whitepages</a> for up to date contact</li>
                                </ul>
                            </div>
                        </div>

                    </div>
                ) : (
                    <div className="claim-btn">
                        
                        <a rel="noopener noreferrer" href={`${getClaimBaseUrl()}/make-a-claim?id=${hit.money}`}>
                            <button>Make a claim</button>
                        </a>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Result;
